import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "../../api/constant";
import type {
    designation,
    designationByIdResponse,
    designationResponse,
} from "@/interface/designation.interface";

export const DesignationService = {
    createDesignation: async (
        payload: designation,
    ): Promise<designationResponse> => {
        const API = `${API_ENDPOINT.Designation}`;
        return callApi<designationResponse>(API, { method: "POST", data: payload });
    },

    getDesignation: async (): Promise<designationResponse> => {
        const API = `${API_ENDPOINT?.Designation}`;
        return callApi<designationResponse>(API, { method: "GET" });
    },

    updateDesignation: async (
        payload: designation,
        id: string,
    ): Promise<designationResponse> => {
        const API = `${API_ENDPOINT?.Designation}/${id}`;
        return callApi<designationResponse>(API, { method: "PUT", data: payload });
    },

    deleteDesignation: async (id: string): Promise<designationResponse> => {
        const API = `${API_ENDPOINT?.Designation}/${id}`;
        return callApi<designationResponse>(API, { method: "DELETE" });
    },

    getDesignationById: async (id: string): Promise<designationByIdResponse> => {
        const API = `${API_ENDPOINT?.Designation}/${id}`;
        return callApi<designationByIdResponse>(API, { method: "GET" });
    },
};
